import fetch from "auth/FetchInterceptor";

const sorteioRespostaService = {};

/**
 * Registra no backend que o profissional confirmou ter respondido a pesquisa
 * do sorteio ("Já respondi"). Usado pra montar a lista do sorteio, já que o
 * formulário antigo não capturava o e-mail. Silencioso (no-notification) pra
 * nunca atrapalhar o uso da plataforma.
 */
sorteioRespostaService.registrarResposta = async function (payload) {
	return fetch({
		url: "/v1/rpc/sorteio-mensalidade/registrar-resposta",
		method: "post",
		data: payload,
		headers: { "no-notification": true },
	});
};

export default sorteioRespostaService;
